export const animateEnter = (element, delay = 1000) => {
    if (element) {
        element.style.display = 'flex';
        element.style.opacity = '0';
        element.classList.remove('hidden');

        wait(() => {
            element.style.opacity = '1';
        }, 0);

        wait(() => {
            element.addEventListener('transitionend', () => {
                element.style.display = 'flex';
            }, { once: true });
        }, delay);
    }
};

export const animateLeave = (element, delay = 0) =>{
    if (element) {
        element.style.opacity = '0';

        wait(() => {
            element.classList.add('hidden');
            element.style.display = 'none';
        }, delay);
    }
};

export const isEmailValid = (email: string) => {
    const emailRegex = /[^@]+@[^.@]+\.[^.@]+/;
    return email.match(emailRegex) && email !== '';
};

export const isPasswordValid = (password: string) => {
    return password.length > 6 && password !== '';
};

const wait = (callback, delay = 1000) => {
    setTimeout(callback, delay);
};

export const DEFAULT_MEMBER_TIMEZONE = 'Europe/Amsterdam';
